import { handleActions } from '@gef-ui/utils/fsaActions';
import mergeDeepRight from "ramda/es/mergeDeepRight";
import alwaysEmptyObject from "ramda-extension/es/alwaysEmptyObject";
import { actionTypes } from '../constants';
export default handleActions({
    [actionTypes.MERGE_APM_CONFIG]: (state, { payload })=>mergeDeepRight(state, payload),
    [actionTypes.CLEAR_APM_CONFIG]: alwaysEmptyObject
}, {});
